import React from 'react'
import { isToday } from 'date-fns'
import { useHistory, useLocation } from 'react-router-dom'
import {
  QuestionnaireSurveys,
  QuestionnaireSurveysVariables,
  SurveyType,
  SURVEYS,
  SortDirectionEnum,
  ILocation,
} from '@modmd/data'
import { EmptyCenteredLayout } from 'client-portal/components/PageLayout'
import { SignInCard } from 'sharedComponents/SignInCard'
import { useApolloClient } from '@apollo/client'
import { PERSONAL_ROUTES, ROUTES } from 'client-portal/constants/routes'

export const SignIn = () => {
  const history = useHistory()
  const location = useLocation<ILocation>()
  const apolloClient = useApolloClient()

  return (
    <EmptyCenteredLayout>
      <SignInCard
        title="Sign in to your account"
        emailLabel="Email"
        emailPlaceholder="Enter your email"
        passwordLabel="Password"
        passwordPlaceholder="Enter your password"
        forgotPasswordLabel="Forgot Password?"
        inviteUserAdditionalText="New user here?"
        inviteUserLinkLabel="Sign up"
        onInviteUserClick={() => history.push(`/${ROUTES.USER_INVITATION}`)}
        signInButtonLabel="Sign in"
        dontHaveAccountLabel="Don’t have an account?"
        onSignInSuccess={async (data) => {
          if (location.state?.from) {
            history.push(location.state.from)
          }
          try {
            const response = await apolloClient.query<
              QuestionnaireSurveys,
              QuestionnaireSurveysVariables
            >({
              query: SURVEYS,
              variables: {
                filterData: {
                  types: [SurveyType.Questionnaire],
                  userIds: [data.User.id],
                },
                pagination: {
                  from: 0,
                  length: 1,
                  sortBy: 'createdAt',
                  direction: SortDirectionEnum.DESC,
                },
              },
              fetchPolicy: 'network-only',
            })
            const lastCreatedQuestionnaire = new Date(response.data.surveys.surveys[0]?.createdAt)
            if (!isToday(lastCreatedQuestionnaire)) {
              history.push(`/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.SESSIONS}`)
            }
          } catch (error) {
            // ignore
          }
        }}
      />
    </EmptyCenteredLayout>
  )
}
